import React from "react";
import { createSelector } from "@reduxjs/toolkit";
import { ApiSelect, TextType } from "@baseTypes/baseType";
import { RootState } from "../../../store";
import { VehiclesTypesState } from "../../../store/reducers/dashboard/vehicles/types/types";
import { identity } from "fp-ts/es6/function";
import { stickerLoadingWithCrop } from "../phases";
import st from './styles.module.scss';
import Sticker from "../../../components/elements/sticker/Sticker";
import { useTypedSelector } from "@hooks/useTypedSelector";
import { isEmpty } from "lodash";
import Empty from "./empty";
import Tx from "@baseTypes/naming";
import StickerHeader from "@elements/sticker/StickerHeader";
import Container from "@elements/container/Container";
import VehiclesTypesChart from "@pages/dashboard/vehiclesTypes/chart";

const selector: ApiSelect<VehiclesTypesState> = createSelector(
	(state: RootState) => state.vehiclesTypes,
	identity<VehiclesTypesState>
)

const VehiclesTypes = () => {
	const { data } = useTypedSelector(state => state.vehiclesTypes)

	const renderContent = () => {
		const dataToRender = [...data].sort((a, b) => a.unitType.localeCompare(b.unitType))

		return (
			<>
				<StickerHeader
					isLink={false}
					textType={TextType.Header}
					title={Tx.VehicleTypes}
				/>
				<Container className={st['container']}>
					<VehiclesTypesChart data={dataToRender} />
				</Container>
			</>
		)
	}

	return (
		<Sticker className={st['sticker']}>
			{!isEmpty(data) ? renderContent() : <Empty />}
		</Sticker>
	)
}

export default stickerLoadingWithCrop(selector, () => () => ([]), { cropEnabled: false })(VehiclesTypes)